import { ApiResponseConvertor } from '@app/shared/utils/api-response-convertor.interface';
import { Injectable } from '@angular/core';

export class UserDocument {
  public id: number;
  public name: string;
  public location: string;
  public key: string;
  public typeId: number;
  public subTypeId: number;
  public createdAt: Date;
  public expirationDate: Date;
  public doesNotExpire: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserDocumentConverter implements ApiResponseConvertor<UserDocument> {
  convert(item: any): UserDocument {
    const userDoc: UserDocument = {
      id: item.id,
      name: item.name,
      location: item.location,
      key: item.key,
      typeId: item.typeId,
      subTypeId: item.subTypeId,
      createdAt: item.created_at,
      expirationDate: item.expirationDate,
      doesNotExpire: item.doesNotExpire,
    };
    return userDoc;
  }
}
